/**
 * Editorial stories — horizontal accordion gallery (desktop), stacked cards (mobile).
 *
 * @package HelloElementorChild
 */

var EDITORIAL_STORIES_MOBILE_MQ = window.matchMedia('(max-width: 1023px)');

function getStoryItems(root) {
  var gallery = root.querySelector('[data-camst-editorial-stories-gallery]');

  if (!gallery) {
    return [];
  }

  return Array.prototype.slice.call(gallery.querySelectorAll('[data-camst-editorial-stories-item]'));
}

function setActiveStoryItem(items, index) {
  items.forEach(function (item, itemIndex) {
    var isActive = itemIndex === index;

    item.classList.toggle('is-active', isActive);
    item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  });
}

function expandAllStoryItems(items) {
  items.forEach(function (item) {
    item.classList.add('is-active');
    item.setAttribute('aria-expanded', 'true');
  });
}

function applyEditorialStoriesLayout(root, items) {
  var activeIndex = items.findIndex(function (item) {
    return item.classList.contains('is-active');
  });

  if (activeIndex < 0) {
    activeIndex = 0;
  }

  if (EDITORIAL_STORIES_MOBILE_MQ.matches) {
    expandAllStoryItems(items);
    root.classList.add('camst-editorial-stories--stacked');
    return;
  }

  root.classList.remove('camst-editorial-stories--stacked');
  setActiveStoryItem(items, activeIndex);
}

function isStackedRoot(root) {
  return root.classList.contains('camst-editorial-stories--stacked');
}

export function initCamstEditorialStories(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-editorial-stories]'));
  } else if (scope.matches && scope.matches('[data-camst-editorial-stories]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-editorial-stories]'));
  }

  roots.forEach(function (root) {
    var items = getStoryItems(root);

    if (!items.length) {
      return;
    }

    applyEditorialStoriesLayout(root, items);

    if (root.dataset.camstEditorialStoriesInit === '1') {
      return;
    }

    var gallery = root.querySelector('[data-camst-editorial-stories-gallery]');

    items.forEach(function (item, index) {
      item.addEventListener('mouseenter', function () {
        if (isStackedRoot(root)) {
          return;
        }

        setActiveStoryItem(items, index);
      });

      item.addEventListener('focus', function () {
        if (isStackedRoot(root)) {
          return;
        }

        setActiveStoryItem(items, index);
      });

      item.addEventListener('click', function (event) {
        if (isStackedRoot(root)) {
          return;
        }

        if (!item.classList.contains('is-active')) {
          event.preventDefault();
          setActiveStoryItem(items, index);
        }
      });
    });

    if (gallery) {
      gallery.addEventListener('mouseleave', function () {
        if (isStackedRoot(root)) {
          return;
        }

        setActiveStoryItem(items, 0);
      });
    }

    function onLayoutChange() {
      applyEditorialStoriesLayout(root, items);
    }

    if (typeof EDITORIAL_STORIES_MOBILE_MQ.addEventListener === 'function') {
      EDITORIAL_STORIES_MOBILE_MQ.addEventListener('change', onLayoutChange);
    } else if (typeof EDITORIAL_STORIES_MOBILE_MQ.addListener === 'function') {
      EDITORIAL_STORIES_MOBILE_MQ.addListener(onLayoutChange);
    }

    root.dataset.camstEditorialStoriesInit = '1';
  });
}

export function teardownCamstEditorialStories(scope) {
  var roots = scope
    ? scope.matches && scope.matches('[data-camst-editorial-stories]')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-editorial-stories]'))
    : [];

  roots.forEach(function (root) {
    delete root.dataset.camstEditorialStoriesInit;
  });
}
